import React from 'react'
import Modal from '../../../commons/Modal'

interface ErrorModalProps {
  closeModal: () => any
}

const ErrorModal: React.FC<ErrorModalProps> = ({ closeModal }) => (
  <Modal title="OPS!" onClose={closeModal}>
    C'è stato un errore, controlla i dati del modulo e riprova tra qualche istante
  </Modal>
)

export default ErrorModal
